import apiClient from '../index';

export const createRecord = async (data) => {
  try {
    const response = await apiClient.post('/api/record/', data);
    return response.data;
  } catch (error) {
    console.error(`Error creating record`, error);
    throw error;
  }
};

export const upsertRecord = async (data) => {
  try {
    const response = await apiClient.put('/api/record/upsert', data);
    return response.data;
  } catch (error) {
    console.error(`Error transacting record`, error);
    throw error;
  }
};

export const getAllRecords = async () => {
  try {
    const response = await apiClient.get('/api/record/');
    return response.data;
  } catch (error) {
    console.error(`Error fetching records`, error);
    throw error;
  }
};

export const getRecordById = async (id) => {
  try {
    const response = await apiClient.get(`/api/record/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching record`, error);
    throw error;
  }
};

export const getRecordByEnrollmentandRecordTypeID = async ([eid, rid]) => {
  try {
    const response = await apiClient.get(
      `/api/record/enrollment?eid=${eid}&rid=${rid}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching record`, error);
    throw error;
  }
};

export const updateRecordById = async ([id, data]) => {
  try {
    const response = await apiClient.put(`/api/record/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating record`, error);
    throw error;
  }
};

export const deleteRecordById = async (id) => {
  try {
    const response = await apiClient.delete(`/api/record/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting record`, error);
    throw error;
  }
};
